import { genericGet } from "./base.api";
import { FullWebConfig } from "types/config";
import { LabelValuePair } from "utils/common";
import { getConfigApiUrl } from "utils/utils";
import config from 'react-global-configuration';
import { UserInfo } from "types/userInfo";
import axios from "axios";

export type AssetPermissionDetails = {
  name: string,
}

export function getWebConfig(): Promise<FullWebConfig> {
  return genericGet(`${getConfigApiUrl()}/all/web`)
}

export function getUserInfo(token: string): Promise<UserInfo> {
  const REACT_CONFIG = config.get();
  const cognitoDomain = REACT_CONFIG.COGNITO_DOMAIN;

  const url = REACT_CONFIG.SHOULD_USE_COGNITO
    ? `https://${cognitoDomain}/oauth2/userInfo`
    : `http://${cognitoDomain}/me`;

  return axios.get(url, { headers: { Authorization: `Bearer ${token}` } })
    .then(res => res.data);
}

export function getAssetTypes(): Promise<LabelValuePair[]> {
  return genericGet(`${getConfigApiUrl()}/document/entity/asset/fields/subtype`)
    .then((res: any) => {
      const entries = Object.entries<string>(res.items);
      const itemsArray = [];
      for (const [key, value] of entries) {
        itemsArray.push({ value: key, label: value });
      }
      return itemsArray
    })
}

export function getOwners(): Promise<LabelValuePair[]> {
  return genericGet(`${getConfigApiUrl()}/document/entity/asset/properties/owner`)
    .then((res: any) => {
      const entries = Object.entries<string>(res.items);
      const itemsArray = [];
      for (const [key, value] of entries) {
        itemsArray.push({ value: key, label: value });
      }
      return itemsArray
    })
}
